/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import kebabCase from 'lodash-es/kebabCase'

import { useWhiteLabelContext } from 'providers/WhiteLabelProvider'
import { SUPPORT_EMAIL } from 'src/localConstants'
import WhiteLabelFooter from '../../partials/WhiteLabelFooter'
import WhiteLabelHeader from '../../partials/WhiteLabelHeader'

import 'sass/global/styles.scss'
import styles from './styles.module.scss'
import { Carousel } from '../../Carousel'

const WhiteLabelLayout = ({
  className,
  location,
  isFullHeight,
  children,
  style,
  pageContext: { video, description, category, videos, videoIndex },
}) => {
  const { alert, setAlert, canAccess } = useWhiteLabelContext()
  const isPrevSameCategoryVideo = location?.state?.prevLocation?.startsWith(
    `/on-demand/${kebabCase(category)}`
  )
  const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    // clear all alerts on page change & scrolls back to top
    setAlert()
    scrollToTop()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const isRedirectPage = location.pathname === '/redirect'
  const isFullHeightPage = isRedirectPage

  // Scroll to top of page when alert is fired
  useEffect(() => {
    // Super hacky, but we need a timer to fix
    // iOS not always scrolling to the top so the
    // alert is in view
    const timer =
      alert &&
      setTimeout(() => {
        scrollToTop()
      }, 500)

    return () => {
      if (alert) clearTimeout(timer)
    }
  }, [alert])

  return (
    <div
      className={classNames(className, styles.page, {
        [styles.isFullHeight]: isFullHeightPage || isFullHeight,
      })}
    >
      <WhiteLabelHeader location={location} />
      <div
        className={classNames(styles.mainWrapper, {
          [styles.isFullHeight]: isFullHeightPage || isFullHeight,
        })}
      >
        <main className={styles.main} id="app-content" style={style}>
          {alert && alert}
          {canAccess && (
            <div>
              <div>{children}</div>
              {video && (
                <div className={styles.carouselContainer}>
                  <Carousel
                    name={category}
                    description={description}
                    initialIndex={videoIndex}
                    items={videos}
                    isSameGroup={isPrevSameCategoryVideo}
                  />
                </div>
              )}
            </div>
          )}

          {!canAccess && (
            <div className={styles.noAccessContent}>
              <h1 className={styles.noAccessTitle}>
                Sorry, this website can't be accessed directly
              </h1>
              <p>
                It must be visited from an eligible referring website. Usually
                this is through an employer, insurance provider, or another
                fitness website.
              </p>
              <p>
                You'll generally see this message when you navigate here via:
              </p>
              <ul>
                <li>A bookmark</li>
                <li>A link shared by someone else</li>
                <li>Your browser history</li>
              </ul>
              <p>
                Unfortunately, there's no way for us to know who originally
                referred you here, but we recommend checking with your employer
                or insurance provider's websites.
              </p>
              <p>
                If you believe you're seeing this message in error, please{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`}>email us</a> {SUPPORT_EMAIL}
              </p>
            </div>
          )}
        </main>
        <div />
      </div>
      <WhiteLabelFooter location={location} />
    </div>
  )
}

WhiteLabelLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

// Make Font Awesome Icons available
library.add(fas, far, fab)

export default WhiteLabelLayout
